export default __webpack_public_path__ + "static/media/Cotton.68986e48.jpg";